import { Menu, MenuProps, Modal } from "antd";
import Cookies from "js-cookie";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authActions } from "../../../redux/slices";
import { RootState } from "../../../redux/store";
import { AdminType, ClientType, ProfessionalType } from "../../../types";
import { ModalContentWrapper, NavText, SignOutBtn, StyledSider } from "./style";

const ClientSidebar = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  const [showSignoutModal, setShowSignoutModal] = useState<boolean>(false);
  const auth = authActions;

  const isClient = (user: ProfessionalType | ClientType | AdminType | null): user is ClientType => {
    return !!user && "professionalCode" in user;
  };

  const onSignOut = () => {
    setShowSignoutModal(false);

    Cookies.remove("user");
    Cookies.remove("auth_token");

    auth.removeAuth();
    if (isClient(user)) {
      window.location.href = `/c/${user.professionalCode}/sign_out`;
    }
  };

  const navItems = [
    {
      icon: <i className="material-icons-outlined icon-font">dashboard</i>,
      label: isClient(user) ? <NavText to={`/c/${user.professionalCode}`}>Dashboard</NavText> : null,
      key: isClient(user) ? `${user.professionalCode}` : "dashboard",
    },
    {
      icon: <i className="material-icons-outlined icon-font">contact_page</i>,
      label: <NavText to="general_client_info">My Info</NavText>,
    },
    {
      icon: <i className="material-icons-outlined icon-font">message</i>,
      label: <NavText to="/">Inmail</NavText>,
    },
    {
      icon: <i className="material-icons-outlined icon-font">power_settings_new</i>,
      label: <SignOutBtn onClick={() => setShowSignoutModal(true)}>Sign Out</SignOutBtn>,
      key: "sign_out",
    },
  ];

  const [collapsed, setCollapsed] = useState<boolean>(false);
  const items: MenuProps["items"] = navItems.map((item, index) => ({
    key: String(index + 1),
    icon: item.icon,
    label: item.label,
  }));

  const handleBack = () => {
    setShowSignoutModal(false);
  };

  return (
    <StyledSider
      collapsible
      collapsed={collapsed}
      breakpoint="xs"
      // collapsedWidth="0"
      onCollapse={(value) => setCollapsed(value)}
      style={{
        overflow: "auto",
        height: "100vh",
        position: "sticky",
        left: 0,
        top: 0,
      }}
    >
      <Modal
        title={`Signout`}
        open={showSignoutModal}
        onOk={onSignOut}
        onCancel={handleBack}
        // footer={null}
        width={350}
      >
        <ModalContentWrapper>
          <span>Are you sure you want to sign out?</span>
        </ModalContentWrapper>
      </Modal>
      <Menu mode="inline" defaultSelectedKeys={["1"]} items={items} />
    </StyledSider>
  );
};

export default ClientSidebar;
